import React from 'react';
import ReactApexChart from 'react-apexcharts';

const MessageAnalyticsChart = (props) => {
  const chartData = {
    categories: props?.data?.labels,
    sent: props?.data?.sent,
    received: props?.data?.received,
  };

  const state = {
    series: [
      {
        name: 'Sent',
        data: chartData.sent || [31, 40, 28, 51, 42, 109, 100],
      },
      {
        name: 'Received',
        data: chartData.received || [30, 45, 25, 50, 40, 100, 90],
      },
    ],
    options: {
      chart: {
        height: 300,
        type: 'area',
        stacked: false,
        toolbar: {
          show: false,
          autoSelected: false,
          tools: {
            download: false,
          },
        },
        zoom: { enabled: false },
      },
      stroke: {
        curve: 'smooth',
        width: 2,
        colors: ['#f4543a'],
      },
      colors: ['#b94feb', '#f4543a'],
      fill: {
        type: 'gradient',
        opacity: 0.6,
        gradient: {
          shade: 'light',
          gradientToColors: ['#f4543a', '#b94feb'],
          inverseColors: false,
          opacityFrom: 0.6,
          opacityTo: 0.3,
          shadeIntensity: 0.5,
          type: 'vertical',
          stops: [0, 90, 100],
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: chartData.categories,
        labels: {
          style: {
            colors: '#666666',
            fontSize: '14px',
          },
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#156BA3',
              colorTo: '#5AC6C6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: '#666666',
            fontSize: '14px',
          },
        },
      },
      grid: {
        borderColor: '#F2ECEC',
        strokeDashArray: 5,
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
    },
  };

  return (
    <div className='react-chart pt-3'>
      <ReactApexChart options={state.options} series={state.series} type='area' height={320} />
    </div>
  );
};

export default MessageAnalyticsChart;
